import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CopyClipboardUniDriver extends BaseUniDriver {}
